// extracted by mini-css-extract-plugin
export default {"container":"qV-z","title":"rV-z","link":"sV-z"};